import { render } from "./TopRatingCourses.vue?vue&type=template&id=06b4809c&scoped=true"
import script from "./TopRatingCourses.vue?vue&type=script&lang=js"
export * from "./TopRatingCourses.vue?vue&type=script&lang=js"

import "./TopRatingCourses.vue?vue&type=style&index=0&id=06b4809c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b4809c"]])

export default __exports__